export default function AppSection() {
  return (
    <section id="app" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-50 rounded-xl p-8 md:p-12 border border-background-200/50">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 mb-4">
              随时随地看爆料
            </h2>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6">
              爆料专区移动端已覆盖 iOS 与 Android 平台，支持推送提醒——
              争议事件爆发第一时间通知你，不错过任何猛料更新。
              夜间模式护眼阅读，离线缓存随时随地深扒。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-md bg-foreground-100 hover:bg-foreground-200 text-background-900 font-medium text-sm transition-colors cursor-pointer"
              >
                <i className="ri-apple-line text-lg"></i>
                App Store
              </a>
              <a
                href="#app"
                className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-md border border-foreground-300/40 hover:border-foreground-200/60 text-foreground-200 font-medium text-sm transition-colors cursor-pointer"
              >
                <i className="ri-android-line text-lg"></i>
                Google Play
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-48 h-80 rounded-2xl overflow-hidden border-4 border-background-200 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20mobile%20app%20interface%20mockup%20showing%20news%20feed%20with%20breaking%20headlines%2C%20red%20and%20amber%20accent%20colors%2C%20modern%20minimal%20UI%20design%2C%20dark%20theme%2C%20sleek%20smartphone%20screen%20display%2C%20clean%20typography%2C%20no%20recognizable%20text&width=400&height=700&seq=app-mockup-expose-01&orientation=portrait"
                alt="爆料专区移动端界面"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}